import { NgBridgeCheckerContext } from '@hotjar/webapp/components/NgBridgeChecker';
import { useContext } from 'react';

/**
 * This hook is added to bridging hooks to be able to trace usage of bridging hooks within component trees.
 *
 * To use this hook, wrap an react component tree in `<NgBridgeCheckerProvider>` to see logs of
 * which components are using bridging hooks.
 */
export const useNgBridgeChecker = (): void => {
  const provided = useContext(NgBridgeCheckerContext);

  if (provided.present && process.env.NODE_ENV === 'development') {
    const err = new Error();

    // eslint-disable-next-line no-console
    console.warn('You are using AngularJS bridging hooks.', err.stack);
  }
};
